import { cn } from '@/lib/utils';

interface BrandMarkProps {
  /** Tamanho do quadro do logo em pixels. */
  size?: number;
  /** Intensidade do halo (0 = sem brilho). */
  glow?: 'none' | 'soft' | 'strong';
  className?: string;
}

/**
 * Marca oficial do FiscalOnne — usa o ícone /favicon-32x32.png (F branco
 * sobre gradiente cyan→roxo). Use este componente em qualquer lockup do
 * logo (sidebar, header, footer, landings) para garantir consistência.
 */
export function BrandMark({ size = 36, glow = 'soft', className }: BrandMarkProps) {
  const halo =
    glow === 'none'
      ? null
      : (
        <div
          aria-hidden
          className={cn(
            'absolute -inset-1 rounded-[inherit] bg-gradient-to-r from-cyan-500 to-purple-600 blur transition duration-500',
            glow === 'soft' ? 'opacity-20 group-hover:opacity-60' : 'opacity-40 group-hover:opacity-100',
          )}
        />
      );

  return (
    <span
      className={cn('relative inline-flex shrink-0', className)}
      style={{ width: size, height: size }}
    >
      {halo}
      <img
        src="/favicon-32x32.png"
        alt="FiscalOnne"
        width={size}
        height={size}
        className="relative z-[1] rounded-lg object-contain"
        draggable={false}
      />
    </span>
  );
}
